import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './CustomFailPage.css';

const CustomFailPage = () => {
    const navigate = useNavigate();

    const handleRetry = () => {
        // Navigate back to the custom content request page
        navigate('/custom-content');
    };

    return (
        <div className="custom-fail-page">
            <div className="fail-container">
                <div className="fail-icon">
                    <svg viewBox="0 0 24 24" width="100" height="100">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                </div>
                <h2>Order Not Completed</h2>
                <div className="fail-message">
                    <p>Your custom content order was not completed.</p>
                    <p>This could be due to a payment issue or because you chose to cancel the checkout process.</p>
                </div>
                <div className="options-list">
                    <h3>What would you like to do?</h3>
                    <div className="options-buttons">
                        <button onClick={handleRetry} className="retry-button">
                            Try Again
                        </button>
                        <Link to="/auth-home" className="return-button">
                            Return to Dashboard
                        </Link>
                    </div>
                </div>
                <div className="help-section">
                    <h3>Need Help?</h3>
                    <p>If you're experiencing issues with the checkout process or have any questions, please contact our support team.</p>
                    <Link to="/contact" className="contact-link">
                        Contact Support
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CustomFailPage;
